module.exports = __webpack_public_path__ + "open2-e2ad93f70dd9fc567aa539992af7409e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/options/open2.png
// module id = 481
// module chunks = 0